"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsOfUsageService = void 0;
class TermsOfUsageService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Termsofusage({ locale, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/termsofusage/{locale}',
            path: {
                locale: locale,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV1Termsofusage({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/termsofusage',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.TermsOfUsageService = TermsOfUsageService;
